import React from 'react';
import DiscoverModeNewVariantPassIcon from '../../icons/DiscoverModeNewVariantPassIcon';

interface IProps {
  onClick: () => void;
  disableManualClick: boolean;
  isDarkMode: boolean;
}

const DashboardDiscoverModeOfferActionPass: React.FC<IProps> = ({ onClick, disableManualClick, isDarkMode = false }: IProps) => {
  const handleClick = () => {
    if (!disableManualClick) {
      onClick();
    }
  };

  return (
    <div onClick={handleClick}>
      <DiscoverModeNewVariantPassIcon isDarkMode={isDarkMode} customStyle={{ cursor: disableManualClick ? 'not-allowed' : 'pointer' }} />
    </div>
  );
};

export default DashboardDiscoverModeOfferActionPass;
